// extracted by mini-css-extract-plugin
export default {"title":"DigitalKeyOwnerDetail_title__vEIEi","subTitle":"DigitalKeyOwnerDetail_subTitle__FOIYF"};